<template>
    <v-card v-bind="{ loading }" flat>
        <v-data-table v-bind="{ headers, items }" :items-per-page="-1" height="400" fixed-header hide-default-footer ref="data-table">
            <template #body="props" v-if="!isCreate">
                <draggable v-if="$refs['data-table']" tag="tbody" :list="props.items" @change="setNewIndex" :sort="!loading">
                    <v-nodes :vnodes="$refs['data-table'].genItems(props.items, props)" />
                </draggable>
            </template>
            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
            <template #[`item.WORK_TYPE`]="{ item }">
                <v-select v-model="item.WORK_TYPE" :items="workTypes" v-bind="{ ...attrs__field }" @input="emit" />
            </template>
            <template #[`item.BOM_LEVEL`]="{ item }">
                <v-text-field v-model="item.BOM_LEVEL" type="number" v-bind="{ ...attrs__field }" @input="emit" />
            </template>
            <template #[`item.ITEM_LEVEL`]="{ item }">
                <v-select v-model="item.ITEM_LEVEL" :items="itemLevels" v-bind="{ ...attrs__field }" @input="emit" />
            </template>
            <template #[`item.ITEMSEQ`]="{ item }">
                <v-text-field v-model="item.ITEMSEQ" type="number" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.WORK_SIDE`]="{ item }">
                <v-select v-model="item.WORK_SIDE" :items="workSides" v-bind="{ ...attrs__field }" @input="emit" />
            </template>
            <template #[`item.ITEM_CODE_P`]="{ item }">
                <v-text-field v-model="item.ITEM_CODE_P" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.ITEM_NAME`]="{ item }">
                <v-text-field v-model="item.ITEM_NAME" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.ITEM_CODE`]="{ item }">
                <v-text-field v-model="item.ITEM_CODE" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.CLASS_CODE`]="{ item }">
                <v-text-field v-model="item.CLASS_CODE" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.CLASS_NAME`]="{ item }">
                <v-text-field v-model="item.CLASS_NAME" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.ITEM_TYPE`]="{ item }">
                <v-text-field v-model="item.ITEM_TYPE" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.ITEM_TYPE_NAME`]="{ item }">
                <v-text-field v-model="item.ITEM_TYPE_NAME" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.REVISION`]="{ item }">
                <v-text-field v-model="item.REVISION" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.RANK`]="{ item }">
                <v-text-field v-model="item.RANK" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.UNIT_QTY`]="{ item }">
                <v-text-field v-model="item.UNIT_QTY" type="number" v-bind="{ ...attrs__field }" @input="emit" />
            </template>
            <template #[`item.CREATE_DATE`]="{ item }">
                <v-text-field v-model="item.CREATE_DATE" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.MAKER_PARTNO`]="{ item }">
                <v-text-field v-model="item.MAKER_PARTNO" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.SPEC`]="{ item }">
                <v-text-field v-model="item.SPEC" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.MAKER_NAME`]="{ item }">
                <v-text-field v-model="item.MAKER_NAME" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.SUPPLIER_NAME`]="{ item }">
                <v-text-field v-model="item.SUPPLIER_NAME" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.DATE_FR`]="{ item }">
                <v-text-field v-model="item.DATE_FR" type="date" v-bind="{ ...attrs__field }" readonly />
            </template>
            <template #[`item.DATE_TO`]="{ item }">
                <v-text-field v-model="item.DATE_TO" type="date" v-bind="{ ...attrs__field }" readonly />
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { attrs_input__table, initDataTableHeaders, initManufacturingBom, initManufacturingBomRow } from "@/assets/variables";

import Draggable from "vuedraggable";

const initForm = ({ bom, rows = [] } = {}) => ({
    bom: initManufacturingBom(bom),
    rows: rows.map(initManufacturingBomRow),
});

const headers = initDataTableHeaders(
    [
        { width: +60, text: "#", value: "ROW_NUM", align: "end", cellClass: "px-4" },
        { width: +80, text: "작업\r\n구분", value: "WORK_TYPE" },
        { width: +80, text: "BOM\r\nLevel", value: "BOM_LEVEL" },
        { width: 140, text: "Level", value: "ITEM_LEVEL" },
        { width: 100, text: "Seq", value: "ITEMSEQ" },
        { width: 100, text: "작업면", value: "WORK_SIDE" },
        { width: 100, text: "모품번\r\n(Assy)", value: "ITEM_CODE_P", cellClass: "text-truncate" },
        // { text: "대체품", value: "" },
        { width: 100, text: "품명", value: "ITEM_NAME", cellClass: "text-truncate" },
        { width: 100, text: "품번", value: "ITEM_CODE", cellClass: "text-truncate" },
        { width: 100, text: "분류\r\n코드", value: "CLASS_CODE", cellClass: "text-truncate" },
        { width: 100, text: "분류\r\n이름", value: "CLASS_NAME" },
        { width: 100, text: "구분\r\n코드", value: "ITEM_TYPE" },
        { width: 100, text: "구분\r\n이름", value: "ITEM_TYPE_NAME" },
        { width: 100, text: "Rev.", value: "REVISION" },
        { width: 100, text: "Rank", value: "RANK" },
        // { text: "Location\r\nNo.", value: "" },
        { width: +60, text: "수량", value: "UNIT_QTY" },
        { width: 140, text: "변경일시", value: "CREATE_DATE", cellClass: "text-truncate" },
        { width: 100, text: "제조사\r\n품번", value: "MAKER_PARTNO", cellClass: "text-truncate" },
        { width: 100, text: "규격", value: "SPEC", cellClass: "text-truncate" },
        { width: 100, text: "제조\r\n업체", value: "MAKER_NAME" },
        { width: 100, text: "구매\r\n업체", value: "SUPPLIER_NAME" },
        // { text: "제작구분", value: "" },
        // { text: "도면Size", value: "" },
        // { text: "비고", value: "" },
        { width: 100, text: "적용일", value: "DATE_FR", cellClass: "text-truncate" },
        { width: 100, text: "종료일", value: "DATE_TO", cellClass: "text-truncate" },
    ],
    {
        showsDivider: true,
        className: "font-size-14 white-space-pre-line",
        cellClass: "caption px-0",
    }
);

export default {
    components: {
        VNodes: { functional: true, render: (h, ctx) => ctx.props.vnodes },
        Draggable,
    },
    props: {
        value: { type: Object, default: initForm },
        isCreate: { type: Boolean, default: false },
    },
    data: () => ({
        form: initForm(),

        headers,
        loading: false,
        workSides: [
            { text: "", value: null },
            { text: "TOP", value: "UP" },
            { text: "BOTTOM", value: "DOWN" },
        ],
        workTypes: ["Edit"],
        itemLevels: new Array(5).fill().map((_, i) => `${i + 1}`.padStart((i + 1) * 3 + 1 + i, ".")),
    }),
    computed: {
        attrs__field() {
            return {
                ...attrs_input__table,
                ["class"]: "caption",
                ["dense"]: true,
                ["readonly"]: this.isCreate,
            };
        },
        items() {
            return this.form?.rows || [];
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync(form = this.value) {
            this.form = initForm(form);
        },
        emit() {
            this.$emit("input", this.form);
        },
        updateItem(element) {
            let index = this.form.rows.findIndex(({ _id }) => _id == element._id);
            this.form.rows.splice(index, element);
        },
        setNewIndex({ moved = {} }) {
            let { element, oldIndex, newIndex } = moved;
            element.ROW_NUM += oldIndex - newIndex;
            this.updateItem(element);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }

    .v-data-table tr td {
        cursor: pointer !important;
    }
}
</style>
